import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IPartnerAuth } from "src/@types/partner-auth";

interface PartnerLoginResponse {
  accessToken: string;
  partner: {
    id: string;
    name: string;
    email: string;
  };
}

export const postPartnerLogin: any = createAsyncThunk<
  PartnerLoginResponse,
  { email: string; password: string }
>("partnerAuth/postPartnerLogin", async ({ email, password }, thunkAPI) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/partner/login`,
      {
        email,
        password,
      },
    );
    return response.data;
  } catch (error: any) {
    const message =
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      "Erro ao fazer login do parceiro.";

    return thunkAPI.rejectWithValue(message);
  }
});

const initialState: IPartnerAuth = {
  accessToken: "",
  partner: {
    id: "",
    name: "",
    email: "",
  },
  isLoading: false,
  sessionExpired: false,
  error: null,
};

const partnerAuthSlice = createSlice({
  name: "partnerAuth",
  initialState,
  reducers: {
    partnerLogout: (state) => {
      state.accessToken = "";
      state.partner = { ...initialState.partner };
      state.isLoading = false;
      state.sessionExpired = false;
      state.error = null;
    },
    partnerSessionExpired: (state) => {
      state.accessToken = "";
      state.partner = { ...initialState.partner };
      state.isLoading = false;
      state.sessionExpired = true;
      state.error = null;
    },
    clearPartnerSessionExpired: (state) => {
      state.sessionExpired = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postPartnerLogin.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(postPartnerLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.accessToken = action.payload.accessToken;
        state.partner = {
          id: action.payload.partner.id,
          name: action.payload.partner.name,
          email: action.payload.partner.email,
        };
        state.sessionExpired = false;
        state.error = null;
      })
      .addCase(postPartnerLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.accessToken = "";
        state.partner = { ...initialState.partner };
        state.error =
          (action.payload as string) ||
          action.error?.message ||
          "Erro ao fazer login do parceiro.";
      });
  },
});

export const { partnerLogout, partnerSessionExpired, clearPartnerSessionExpired } =
  partnerAuthSlice.actions;

export default partnerAuthSlice.reducer;
